import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import booking_45param_45guard_45global from "/app/middleware/booking-param-guard.global.ts";
import drop_45incorrect_45dates_45global from "/app/middleware/dropIncorrectDates.global.ts";
import drop_45incorrect_45quote_45properties_45global from "/app/middleware/dropIncorrectQuoteProperties.global.ts";
import gtm_45page_45data_45layer_45global from "/app/middleware/gtmPageDataLayer.global.ts";
import handle404_45global from "/app/middleware/handle404.global.ts";
import http_45headers_45global from "/app/middleware/httpHeaders.global.ts";
import router_45client_45route_45changed_45global from "/app/middleware/routerClientRouteChanged.global.ts";
import set_45page_45header_45global from "/app/middleware/setPageHeader.global.ts";
import trailing_45slash_45global from "/app/middleware/trailingSlash.global.ts";
import unique_45facets_45global from "/app/middleware/unique-facets.global.ts";
import update_45bounds_45params_45global from "/app/middleware/updateBoundsParams.global.ts";
import version_45header_45global from "/app/middleware/versionHeader.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  booking_45param_45guard_45global,
  drop_45incorrect_45dates_45global,
  drop_45incorrect_45quote_45properties_45global,
  gtm_45page_45data_45layer_45global,
  handle404_45global,
  http_45headers_45global,
  router_45client_45route_45changed_45global,
  set_45page_45header_45global,
  trailing_45slash_45global,
  unique_45facets_45global,
  update_45bounds_45params_45global,
  version_45header_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-redirect": () => import("/app/middleware/auth-redirect.ts"),
  "maps-url-redirect": () => import("/app/middleware/mapsUrlRedirect.ts")
}